/* Clarion Camping — gear finder.
   Four questions, then a recommendation assembled from the kits the section
   defines. Degrades to a static fallback if this file never loads. */
(function () {
  function init(root) {
    if (!root || root.dataset.ccReady === '1') return;
    root.dataset.ccReady = '1';

    var data = {};
    try {
      data = JSON.parse(root.querySelector('[data-cc-kits]').textContent) || {};
    } catch (e) {
      return;
    }

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var result = root.querySelector('[data-result]');
    var backBtn = root.querySelector('[data-back]');
    var counter = root.querySelector('[data-counter]');
    if (!steps.length || !result) return;

    /* The fallback is a SIBLING of this element, not a child — scope the
       lookup to the section or it is never found and both panels render. */
    var scope = root.closest('[data-cc-section="finder"]') || document;
    var fallback = scope.querySelector('[data-fallback]');
    if (fallback) fallback.hidden = true;
    root.hidden = false;

    var answers = { who: '', tent: '', cold: '', have: [] };
    var at = 0;

    /* Never move focus on the first paint. Calling .focus() during boot scrolls
       the browser to this section, which hijacks the top of the homepage. */
    function show(i, moveFocus) {
      at = i;
      steps.forEach(function (s, n) { s.hidden = n !== i; });
      result.hidden = true;
      dots.forEach(function (d, n) {
        d.setAttribute('data-on', n <= i ? 'true' : 'false');
      });
      if (backBtn) backBtn.hidden = i === 0;
      if (counter) counter.textContent = 'Question ' + (i + 1) + ' of ' + steps.length;
      if (!moveFocus) return;
      var h = steps[i].querySelector('.cc-quiz__q');
      if (h && h.focus) {
        try { h.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      }
    }

    function decide() {
      var a = answers;
      var have = a.have;
      var primary;

      if (have.indexOf('nothing') > -1 && a.who !== 'family') primary = 'weekend';
      else if (a.who === 'solo') primary = 'solo';
      else if (a.who === 'two') primary = 'two';
      else if (a.who === 'family') primary = have.indexOf('light') > -1 ? 'family' : 'kids';
      else primary = 'weekend';

      var addons = [];
      function add(k) {
        if (k && k !== primary && addons.indexOf(k) === -1 && data[k]) addons.push(k);
      }

      var tentKey = '';
      if (a.tent === 'buy' || a.tent === 'unsure') {
        if (a.who === 'solo') tentKey = 'tent2';
        else if (a.who === 'two') tentKey = 'tent4';
        else if (a.who === 'family') tentKey = 'tent6';
        else tentKey = 'tent4';
        add(tentKey);
      }

      if (have.indexOf('light') === -1) add('afterdark');
      if (a.cold === 'cold') add('sleep');
      if (have.indexOf('seat') === -1) add(a.who === 'family' ? 'basecamp' : 'slowmorning');
      if (a.who === 'dog') add('pets');
      addons = addons.slice(0, 3);

      var why = [];
      if (have.indexOf('nothing') > -1) why.push('You are starting from nothing, so this is the shortest complete list rather than the biggest one.');
      if (a.who === 'family') why.push('With kids along, the two things that decide the trip are a light each and warmth underneath — not extra equipment.');
      if (a.who === 'two') why.push('For two people the honest answer is less gear and better light.');
      if (a.who === 'solo') why.push('Solo means self-contained: sleep, light and one hot meal, nothing borrowed.');
      if (a.who === 'dog') why.push('Bringing a dog changes water and containment more than it changes your kit.');
      if (tentKey) why.push('We have sized the tent for the group you told us about, not for the number on the box — a rated 4-person tent is comfortable for three.');
      if (a.tent === 'borrow') why.push('You are borrowing a tent, so there is no shelter in this list. That is the right call for a first trip — spend the money on the pad underneath you instead.');
      if (a.tent === 'own') why.push('You already have a tent, so every dollar here goes into what happens inside and around it.');
      if (a.tent === 'hammock') why.push('A hammock exposes your whole underside to moving air, so insulation matters more, not less.');
      if (a.cold === 'cold') why.push('Below 45°F the pad matters more than the bag. That is why insulation is in your list twice.');
      if (a.cold === 'unknown') why.push('You are not sure how cold it gets, so we have assumed shoulder season and erred warm.');
      if (have.indexOf('light') === -1) why.push('You have no lighting yet. That is the single most common reason a first trip feels like a bad one.');
      if (have.indexOf('seat') === -1) why.push('Nowhere comfortable to sit is what sends everyone into the tent by eight.');

      render(primary, addons, why.slice(0, 4));
    }

    function card(k, isPrimary) {
      var kit = data[k];
      if (!kit) return '';
      var img = kit.img ? '<div class="cc-qr__media"><img src="' + kit.img + '" alt="" loading="lazy"></div>' : '';
      var price = kit.price ? '<span class="cc-qr__price">' + kit.price + '</span>' : '';
      var save = kit.save ? '<span class="cc-qr__save">' + kit.save + '</span>' : '';
      return (
        '<a class="cc-qr__card' + (isPrimary ? ' cc-qr__card--main' : '') + '" href="' + kit.url + '">' +
        img +
        '<div class="cc-qr__body">' +
        (isPrimary ? '<p class="cc-qr__flag">Your match</p>' : '') +
        '<h4>' + kit.title + '</h4>' +
        '<p>' + (kit.blurb || '') + '</p>' +
        '<div class="cc-qr__meta">' + price + save + '</div>' +
        '</div></a>'
      );
    }

    function render(primary, addons, why) {
      var html = '<p class="cc-eyebrow">Based on your four answers</p>';
      html += '<h3 class="cc-h3">' + (root.dataset.resultHeading || 'Start here.') + '</h3>';
      html += '<div class="cc-qr__grid">' + card(primary, true);
      addons.forEach(function (k) { html += card(k, false); });
      html += '</div>';
      if (why.length) {
        html += '<ul class="cc-qr__why">';
        why.forEach(function (r) { html += '<li>' + r + '</li>'; });
        html += '</ul>';
      }
      html += '<div class="cc-qr__actions">' +
        '<a class="cc-btn" href="' + (root.dataset.allUrl || '/collections/bundles-kits') + '">Compare every kit</a>' +
        '<a class="cc-btn cc-btn--ghost" href="' + (root.dataset.askUrl || '/pages/contact') + '">Have us check it</a>' +
        '<button type="button" class="cc-btn cc-btn--ghost" data-restart>Start over</button>' +
        '</div>';

      result.innerHTML = html;
      steps.forEach(function (s) { s.hidden = true; });
      if (backBtn) backBtn.hidden = true;
      if (counter) counter.textContent = 'Your result';
      dots.forEach(function (d) { d.setAttribute('data-on', 'true'); });
      result.hidden = false;
      try { result.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }

      var again = result.querySelector('[data-restart]');
      if (again) {
        again.addEventListener('click', function () {
          answers = { who: '', tent: '', cold: '', have: [] };
          var pressed = root.querySelectorAll('[aria-pressed="true"]');
          for (var i = 0; i < pressed.length; i++) pressed[i].setAttribute('aria-pressed', 'false');
          show(0, true);
        });
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-a]');
      if (!btn || !root.contains(btn)) return;
      var field = btn.getAttribute('data-field');
      var value = btn.getAttribute('data-a');

      if (field === 'have') {
        if (value === 'nothing') {
          answers.have = answers.have.indexOf('nothing') > -1 ? [] : ['nothing'];
        } else {
          answers.have = answers.have.filter(function (v) { return v !== 'nothing'; });
          var i = answers.have.indexOf(value);
          if (i > -1) answers.have.splice(i, 1);
          else answers.have.push(value);
        }
        var opts = btn.closest('[data-step]').querySelectorAll('[data-a]');
        for (var n = 0; n < opts.length; n++) {
          opts[n].setAttribute('aria-pressed', answers.have.indexOf(opts[n].getAttribute('data-a')) > -1 ? 'true' : 'false');
        }
        return;
      }

      answers[field] = value;
      var sibs = btn.closest('[data-step]').querySelectorAll('[data-a]');
      for (var s = 0; s < sibs.length; s++) {
        sibs[s].setAttribute('aria-pressed', sibs[s] === btn ? 'true' : 'false');
      }
      window.setTimeout(function () {
        if (at < steps.length - 1) show(at + 1, true);
        else decide();
      }, 160);
    });

    var next = root.querySelector('[data-next]');
    if (next) {
      next.addEventListener('click', function () {
        if (at < steps.length - 1) show(at + 1, true);
        else decide();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (at > 0) show(at - 1, true);
      });
    }

    show(0, false);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-cc-finder]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();